'use strict';

var sleeknote = sleeknote || {};

sleeknote.frontpage = sleeknote.frontpage || function () {

    function init() {
        frontpageinits();
    }

    function frontpageinits(){

        $(document).ready(function(){

            if ( matchMedia('screen and (max-width: 767px)').matches ) {

                $('#multiplegoals-carousel-js').flickity({
                    cellAlign: 'center',
                    lazyLoad: true,
                    pageDots: false,
                    prevNextButtons: false,
                    adaptiveHeight: false,
                    imagesLoaded: true,
                    freeScroll: true,
                    percentPosition: false
                });

                $('#logowall-logos-js').flickity({
                    cellAlign: 'left',
                    lazyLoad: true,
                    pageDots: false,
                    prevNextButtons: false,
                    adaptiveHeight: false,
                    imagesLoaded: true,
                    freeScroll: true,
                    percentPosition: false
                });
            }

            

            if ( matchMedia('screen and (min-width: 768px)').matches ) {

                var res = Splitting({
                    target: 'body.home .split-heading, body .frontpage-blocks .split-heading',
                    by: 'lines',
                });

                res.forEach((splitResult) => {
                    const wrappedLines = splitResult.lines.map((wordsArr) => `
                        <span class="line"><span class="mask-up">
                            ${wordsArr.map((word) => `${word.outerHTML}<span class="whitespace">
                        </span>`).join('')}
                    </span></span>`).join('');
                    splitResult.el.innerHTML = wrappedLines;
                });

                inView.threshold(0.75);
                inView(".split-heading").on("enter", function(el) {
                    if (!el.classList.contains("has-animated")) {
                        el.classList.add("show");
                        anime({
                            targets: el.querySelectorAll(".mask-up"),
                            translateY: ["100%", "0%"],
                            duration: 1500,
                            delay: anime.stagger(250),
                            easing: "easeOutQuint",
                            autoplay: true
                        });
                        el.classList.add("has-animated");

                        var tl = anime.timeline({
                            easing: 'easeOutExpo',
                            duration: 1000
                        });

                        tl

                        .add({
                            targets: '.home .site-head',
                            translateY:[-100,0],
                            duration:250
                        })
                        .add({
                            targets: '.frontpage-browser-img',
                            scale: [2,1],
                            delay: 500
                        })
                        .add({
                            targets: '.frontpage-browser-pop',
                            translateX: [600,0],
                            translateY: [200,0],
                            opacity: [0,1],
                        }, '-=700')
                        .add({
                            targets: '.browser-headline',
                            translateX: [300,0],
                            translateY: [-100,0],
                            delay: anime.stagger(100)
                        }, '-=1000')
                        .add({
                            targets: '.browser-text',
                            translateX: [300,0],
                            delay: anime.stagger(100)
                        }, '-=1000')
                        .add({
                            targets: '.browser-button',
                            translateX: [300,0],
                            translateY: [100,0],
                            delay: anime.stagger(100)
                        }, '-=1000')
                        .add({
                            targets: '.frontpage-browser-outline',
                            opacity: [0,1],
                        }, '-=700')
                        .add({
                            targets: '.frontpage-browser-buttons',
                            opacity: [0,1],
                        }, '-=1000')
                        .add({
                            targets: '.frontpage-header-inner p, .frontpage-header-inner a, .frontpage-header-inner ul',
                            translateY:[100,0],
                            opacity:[0,1]
                        }, '1200')
                        ;
                        // keyframes: [
                        //     {translateY: -40},
                        //     {translateX: 250},
                        //     {translateY: 40},
                        //     {translateX: 0},
                        //     {translateY: 0}
                        // ],
                    }
                });

                
                
            }
        });

    }


    return {
        init:init
    };


}();